//The expected data format is an object of key:value pairs per row - where the key corresponds to one of the headers
export const Table = ({headers, data, onRowClick, mappingFunctions = {}, rowStyles = {}, headerStyles = {}}) => {

    return (
        <div style={{display: "flex", width: "100%", justifyContent: "center"}}>
            <table style={{tableLayout: "fixed", borderSpacing: "0px 4px"}}>
                <thead>
                <tr>
                    {headers.map((value) => {
                        const capitalizedHeader = value.charAt(0).toUpperCase() + value.slice(1)
                        return <th style={{padding: '1rem', textAlign: "center", ...headerStyles}}
                                   key={value}>{capitalizedHeader}</th>
                    })}
                </tr>
                </thead>
                <tbody style={{width: "100%"}}>
                {data.map((row, index) => {
                    return <tr key={index} onClick={() => onRowClick && onRowClick(row)} style={{cursor: onRowClick ? "pointer" : "default"}}>
                        {headers.map((value) => {
                            return <td style={{padding: '1rem', textAlign: "center", ...rowStyles}}
                                       key={value}>{mappingFunctions[value] ? mappingFunctions[value](row[value]) : row[value]}</td>
                        })}
                    </tr>
                })}
                </tbody>
            </table>
        </div>
    )
}